import "./GiftPart.css";
import React from "react";
import chatLeft from "../../assets/images/giftRounds/chatLeft.png";
import chatRight from "../../assets/images/giftRounds/chatRight.png";
import curveUp from "../../assets/images/giftRounds/curveUp.png";
import dots from "../../assets/images/giftRounds/dots.png";
import playBig from "../../assets/images/giftRounds/playBig.png";
import playSmall from "../../assets/images/giftRounds/playSmall.png";
import giftIconGray from "../../assets/newImages/giftIconGray.svg";
import giftIconWhite from "../../assets/newImages/giftIconWhite.svg";
import sticker0 from "../../assets/allStickersNew/stickerBill.svg";
import sticker1 from "../../assets/allStickersNew/stickerCallMe.svg";
import sticker2 from "../../assets/allStickersNew/stickerCans.svg";
import sticker3 from "../../assets/allStickersNew/stickerGoodWork.svg";
import sticker4 from "../../assets/allStickersNew/stickerGottaGo.svg";
import sticker5 from "../../assets/allStickersNew/stickerHappy.svg";
import sticker6 from "../../assets/allStickersNew/stickerLetsGo.svg";
import sticker7 from "../../assets/allStickersNew/stickerLowEnergy.svg";
import sticker8 from "../../assets/allStickersNew/stickerMissYou.svg";
import sticker9 from "../../assets/allStickersNew/stickerNice100.svg";
import sticker10 from "../../assets/allStickersNew/stickerPleasure.svg";
import sticker11 from "../../assets/allStickersNew/stickerStayHome.svg";

import { saveAs } from "file-saver";
import JSZip from "jszip";

function GiftPart({
  setPhase,
  phase,
  seenAll,
  allContent,
}) {
  const stickers = [
    sticker0,
    sticker1,
    sticker2,
    sticker3,
    sticker4,
    sticker5,
    sticker6,
    sticker7,
    sticker8,
    sticker9,
    sticker10,
    sticker11,
  ];

  const handleDownloadStickers = async () => {
    const zip = new JSZip();

    await Promise.all(
      stickers.map(async (sticker, index) => {
        const response = await fetch(sticker);
        const blob = await response.blob();
        zip.file(`sticker${index + 1}.svg`, blob, { binary: true });
      })
    );

    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "stickers.zip");
    });
  };

  return (
    <div
      className={
        phase === 6
          ? "giftContainer width1090 weekAnimation"
          : "giftContainer width80"
      }
    >
      <div
        className={
          seenAll && phase === 6
            ? "giftContainerContent shadowLeft backgroundGiftPart"
            : "giftContainerContent shadowLeft"
        }
      >
        <div
          onClick={() => {
            if (seenAll === true) {
              setPhase(6);
            }
          }}
          className={(() => {
            switch (true) {
              case seenAll:
                return "weekText purpleWeek";
              default:
                return "weekText grayWeek";
            }
          })()}
        >
          <p>
            <img
              src={seenAll ? giftIconWhite : giftIconGray}
              alt="giftIcon"
              className="giftIconImage"
            />
          </p>
          <p>{allContent.gift.weekGift}</p>
        </div>
        <div className={phase === 6 ? "displayNone" : "episodeText"}>
          {allContent.gift.getGift}
        </div>
        <div
          className={(() => {
            switch (phase) {
              case 6:
                return "insadeOfGift";
              default:
                return "displayNone";
            }
          })()}
        >
          <div className="giftContent">
            <div className="textGift">
              <h3>{allContent.gift.title1}</h3>
              <h2>{allContent.gift.title2}</h2>
              <p>{allContent.gift.description1}</p>
              <p> {allContent.gift.description2}</p>
            </div>
            <div className="allStickers">
              <img
                className={
                  !seenAll
                    ? "opacityAllStickers allStickersFinish"
                    : "allStickersFinish"
                }
                src={allContent.gift.stickers}
                alt="allStickers"
              />
              <button
                disabled={seenAll ? false : true}
                onClick={handleDownloadStickers}
                className={(() => {
                  switch (true) {
                    case seenAll:
                      return "mainButtonApp buttonTopMargin";
                    default:
                      return "mainButtonApp buttonGrayBackgound buttonTopMargin";
                  }
                })()}
              >
                {allContent.gift.button}
              </button>
            </div>
          </div>
          <img className="allRounds chatLeftGiftPart" src={chatLeft} alt="" />
          <img className="allRounds chatRightGiftPart" src={chatRight} alt="" />
          <img className="allRounds curveUpGiftPart" src={curveUp} alt="" />
          <img className="allRounds dotsGiftPart" src={dots} alt="" />
          <img className="allRounds playSmallGiftPart" src={playSmall} alt="" />
        </div>
        <img
          className={phase === 6 ? "allRounds playBigGiftPart" : "displayNone"}
          src={playBig}
          alt=""
        />
        <div className={seenAll ? "displayNone" : "lightOverlay"}></div>
      </div>
    </div>
  );
}

export default GiftPart;
